import { createI18n } from "vue-i18n";
import en from "@/lang/en.json";
import zh from "@/lang/zh.json";
import ja from "@/lang/ja.json";

const messages = {
  en,
  zh,
  ja,
};

const i18n = createI18n({
  legacy: false,
  globalInjection: true, // 全局注册 $t方法
  locale: window.g.LANG, // 默认语言
  fallbackLocale: "zh", // 回退语言
  messages,
});

export default i18n;
